import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ApolloProvider} from "react-apollo";
import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from "apollo-boost";
import {BrowserRouter as Router} from "react-router-dom";
import Route from "react-router-dom/Route";
import {CIBER_SCHEMA} from "./apollo/Schema";
import InscriptionApp from "./main/InscriptionApp";
import './styles/DatePicker.css';

let httpLink;

const publicUrl = process.env.PUBLIC_URL || '';

if (publicUrl.indexOf('migracionappsprod') >= 0) {
  httpLink = new HttpLink({uri: 'https://migracionappsprod.cibercolegios.com/api/vendorsauth'});
} else if (publicUrl.indexOf('appsprod') >= 0) {
  httpLink = new HttpLink({uri: 'https://appsprod.cibercolegios.com/api/vendorsauth'});
} else {
  httpLink = new HttpLink({uri: 'https://appstest.cibercolegios.com/api/vendorsauth'});
}

const authLink = new ApolloLink((operation, forward) => {
  let loc = window.location.href;
  operation.setContext({
    headers: {
      auth_token: loc.split("/")[loc.split("/").length-1]
    }
  });

  return forward(operation);
});

const client = new ApolloClient({
  link: authLink.concat(httpLink), // Chain it with the HttpLink
  cache: new InMemoryCache(),
  typeDefs: CIBER_SCHEMA
});

function App() {
  return (
    <ApolloProvider client={client}>
      <div className="App">
        <div className="container">
          <br/>
          <Router>
            <Route path="/" component={InscriptionApp} />
          </Router>
        </div>
      </div>
    </ApolloProvider>
  );
}

export default App;
